/* eslint-disable default-case */
const initState = {
  featuredArticles: [],
  listCategories: [],
  // slugColorCategories: {
  //   photography: 'background3',
  //   'web-development': 'background2',
  //   'cong-nghe': 'background4',
  //   'doanh-nghiep': 'background1',
  //   'thi-truong': 'background5',
  // },
};

const ArticleReducer = (state = initState, action) => {
  switch (action.type) {
    case 'SET_LIST_FEATURED_ARTICLE':
      return {
        ...state,
        featuredArticles: action.payload,
      };
    case 'SET_CATEGORIES_ARTICLE':
      return {
        ...state,
        listCategories: action.payload,
      };
    default:
      return { ...state };
  }
};

export default ArticleReducer;
